export default __webpack_public_path__ + "static/media/t-bone-dog.59eb035b.png";